<template>
  <div class="micro-bars">
    <svg ref="svg" :width="size.width" :height="size.height"><defs /></svg>
    <Transition name="fade">
      <div v-if="tooltip" class="tooltip" :style="fixedTooltip || {top: tooltip.top, left: tooltip.left}">
        <!-- <div class="value">{{ tooltip.count }} </div> -->
        <div class="value">{{ (tooltip.count/data.count*100).toFixed(0) }}% </div>
        <div class="label"> {{ tooltip.label }}</div>
      </div>
    </Transition>
  </div>
</template>

<script>
import {select as d3_select} from 'd3-selection'
import {max as d3_max} from 'd3-array'
import {axisBottom as d3_axisBottom} from 'd3-axis'
import {scaleBand as d3_scaleBand, scaleLinear as d3_scaleLinear} from 'd3-scale'
import {bcnColors} from '@/utils/colorUtils'
import Size from '@/mixins/Size'
export default {
  
  mixins:[Size],
  props: ['data','fixedTooltip'],
  data(){
    return {
      tooltip: null
    }
  },
  watch:{
    size(){
      this.drawChart()
    }
  },
  mounted() {
    this.drawChart()
  },
  methods:{
    drawChart(){
      if(!this.data) return
      let width = this.size.width
      let height = this.size.height-5
      let x = d3_scaleBand().domain(this.data.values.map((d)=>d.label)).range([0,width]).padding(0.3)
      let y = d3_scaleLinear().domain([0,d3_max(this.data.values,(d)=>d.count)]).range([height,0])
      let root = d3_select(this.$refs.svg).selectAll('.root').data([null])
      root = root.merge(root.enter().append('g').attr('class','root'))
      console.log("bardata",this.data.values)
      let items = root.selectAll('.item').data(this.data.values,(d)=>d.label)
      let itemsEnter = items.enter().append('g').attr('class','item')
      itemsEnter.append('rect')
      items = items.merge(itemsEnter)
      items.select('rect')
        .attr('x',(d)=>x(d.label))
        .attr('y',(d)=>y(d.count))
        .attr('width',()=>x.bandwidth())
        .attr('height',d=>y(0) - y(d.count))
        .attr('fill',(d,i)=>bcnColors[i])
      // root.attr('transform',`translate(${width/2},${height/2})`)
      items.on('mouseenter',(e,d)=>{
        this.tooltip = {...d, top: 0+'px',left:x(d.label)+'px'}
        items.classed('active',(dd)=>dd===d).classed('innactive',(dd)=>dd!==d)
      })
      items.on('mouseleave',()=>{
        this.tooltip=null
        items.classed('active',false).classed('innactive',false)
      })
      
      let axis = root.selectAll('.axis').data([null])
      axis = axis.merge(axis.enter().append('g').attr('class','axis'))
      let xAxis = d3_axisBottom(x).tickSize(0).tickValues([])
      axis.call(xAxis)
      axis.attr('transform',`translate(0,${height})`)
    }
  }
}
</script>

<style lang="stylus" scoped>
.micro-bars
  display flex
  width 100%
  height 100%

</style>
